const map = {
	"./ECOMMERCE.png": 8991,
	"./EDUCATION.png": 2593,
	"./EDUCATION1.png": 5452,
	"./FINANCIAL_SERVICES.png": 4403,
	"./FOOD_BEVERAGE.png": 9219,
	"./Isolation_Mode.png": 6509,
	"./airtel.png": 6760,
	"./angle_right.png": 5873,
	"./captcha-icon.png": 2979,
	"./check_icon.png": 2043,
	"./close.png": 1087,
	"./digilocker.png": 4866,
	"./forgot_iocn.png": 5308,
	"./frame.png": 4004,
	"./gaming.png": 2524,
	"./indian_flag.png": 8309,
	"./insta-icon.png": 334,
	"./kyc/AccountDetails.png": 5620,
	"./kyc/AuthorizedSignatory.png": 1480,
	"./kyc/BusinessCategory.png": 3011,
	"./kyc/BusinessIdProof.png": 1664,
	"./kyc/Done.png": 9629,
	"./kyc/EnterPAN.png": 4546,
	"./kyc/GstDetails.png": 1769,
	"./kyc/IdProof.png": 670,
	"./kyc/PersonalPan.png": 9784,
	"./kyc/VerifyPAN.png": 965,
	"./kyc/add_location.png": 2408,
	"./link-icon.png": 3689,
	"./myntra.png": 5564,
	"./onboarding_bg.png": 8476,
	"./paisabazaar.png": 7708,
	"./pb.png": 9977,
	"./pb_pay_logo.png": 6602,
	"./pbpartner.png": 7115,
	"./pencil-icon.png": 920,
	"./quickfix.png": 2229,
	"./success-icon.png": 5310,
	"./sucess_checked.png": 3303,
	"./travel-item.png": 1855,
	"./update_password.png": 1886,
	"./upload-icon.png": 1932,
	"./verify_otp.png": 6230,
	"./visit.png": 4226
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5336;